module.exports = __webpack_public_path__ + "img/r_kf.c903c731.svg";